import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { makeStyles, ListSubheader, MenuItem } from '@material-ui/core';
import styled, { useTheme } from 'styled-components';

import { Flex, SvgIcon as BaseSvgIcon } from 'Components/Base';
import { get as getTheme } from 'Components/Base/constants';

const SuggestionWrapper = styled((props) => <Flex flexDirection={'column'} {...props} />)`
  background-color: ${getTheme('colors.white')};
  border-radius: 8px;
  box-shadow: 0 2px 4px 0px rgba(0, 0, 0, 0.1);
  overflow: hidden;
`;

const subHeaderStyle = makeStyles({
  root: ({ colors }) => ({
    fontFamily: 'Noto Sans, Noto Sans Thai, sans-serif',
    fontSize: '16px',
    fontWeight: '600',
    background: colors.notiGrey.grey3,
    color: colors.text,
  }),
});

const menuStyle = makeStyles({
  root: ({ colors }) => ({
    fontFamily: 'Noto Sans, Noto Sans Thai, sans-serif',
    fontSize: '16px',
    color: colors.text,
    background: colors.white,
  }),
});

const SvgIcon = styled(BaseSvgIcon)`
  font-size: 30px;
  color: ${({ theme }) => theme.colors.notiGrey.grey3};
  transform: rotate(-90deg);
  position: relative;
  left: 32px;
  top: 10px;
`;

const SearchSuggestionList = ({
  searchHistoryLists,
  searchItems,
  onSaveSearchHistoryLists,
  onHandleCloseSearchSuggestion,
  onUpdateSearchTerm,
  onLogCourseSearch,
}) => {
  const { colors } = useTheme();
  const subHeaderClasses = subHeaderStyle({ colors });
  const menuClasses = menuStyle({ colors });

  return (
    <Fragment>
      {searchItems.map((searchItem) => {
        const searchItemList = searchItem.items ? searchItem.items : searchHistoryLists;
        return (
          <Fragment key={'searchSuggestion' + searchItem.title}>
            {searchItemList.length > 0 && (
              <ListSubheader classes={subHeaderClasses}>{searchItem?.title}</ListSubheader>
            )}
            {searchItemList.map((item, index) => (
              <MenuItem
                classes={menuClasses}
                key={'searchSuggestion' + index}
                onMouseDown={(e) => {
                  e.preventDefault();
                }}
                onClick={() => {
                  onUpdateSearchTerm(item);
                  onSaveSearchHistoryLists(item);
                  onLogCourseSearch(item);
                  onHandleCloseSearchSuggestion();
                }}
              >
                {item}
              </MenuItem>
            ))}
          </Fragment>
        );
      })}
    </Fragment>
  );
};

const SearchSuggestion = ({
  searchItems,
  onHandleCloseSearchSuggestion,
  searchHistoryLists,
  saveSearchHistoryLists,
  updateSearchTerm,
  logCourseSearch,
  ...props
}) => {
  return (
    <Flex
      flexDirection="column"
      height="auto"
      width="100%"
      style={{ position: 'absolute', top: '30px' }}
      {...props}
    >
      {searchItems?.length > 0 && <SvgIcon icon={SvgIcon.ICON_LIST.PLAY} />}
      <SuggestionWrapper>
        <SearchSuggestionList
          searchHistoryLists={searchHistoryLists}
          searchItems={searchItems}
          onSaveSearchHistoryLists={saveSearchHistoryLists}
          onHandleCloseSearchSuggestion={onHandleCloseSearchSuggestion}
          onUpdateSearchTerm={updateSearchTerm}
          onLogCourseSearch={logCourseSearch}
        />
      </SuggestionWrapper>
    </Flex>
  );
};

SearchSuggestion.propTypes = {
  searchHistoryLists: PropTypes.array,
  onHandleCloseSearchSuggestion: PropTypes.func,
  saveSearchHistoryLists: PropTypes.func,
  searchItems: PropTypes.array,
  updateSearchTerm: PropTypes.func,
  logCourseSearch: PropTypes.func,
};

SearchSuggestionList.propTypes = {
  searchHistoryLists: PropTypes.array,
  onHandleCloseSearchSuggestion: PropTypes.func,
  onSaveSearchHistoryLists: PropTypes.func,
  searchItems: PropTypes.array,
  onUpdateSearchTerm: PropTypes.func,
  onLogCourseSearch: PropTypes.func,
};

export default SearchSuggestion;
